import React from 'react';

import ApplicationLayout from 'components/ApplicationLayout';
import AppTimeoutModal from 'features/TimeoutModal/AppTimeoutModal';
import UnloadPrompt from 'components/UnloadPrompt';

const ApplicationRoute: React.FC = ({ children }) => {
  return (
    <UnloadPrompt>
      <AppTimeoutModal>
        <ApplicationLayout>{children}</ApplicationLayout>
      </AppTimeoutModal>
    </UnloadPrompt>
  );
};

export default ApplicationRoute;
